import { useMutation } from "react-query";
import logout from "../services/logout";

const useLogoutMutation = () => {
  return useMutation(["logout"], logout);
};

export default useLogoutMutation;
